import { render } from "./fleet.cattle.io.clustergroup.vue?vue&type=template&id=230018c5"
import script from "./fleet.cattle.io.clustergroup.vue?vue&type=script&lang=js"
export * from "./fleet.cattle.io.clustergroup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__